import { render, staticRenderFns } from "./Pembayaran.vue?vue&type=template&id=3fc36784&"
import script from "./Pembayaran.vue?vue&type=script&lang=js&"
export * from "./Pembayaran.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports